import { defineNuxtRouteMiddleware, useNuxtApp } from '#imports';

export default defineNuxtRouteMiddleware((to, from) => {
  const { $info } = useNuxtApp();
  $info({
    event: 'view',
    message: `[move]${to.path}`,
  });
});
